import React from "react";
import { Badge } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CourseSubject = props => {
  if (props.subject === null) {
    return <div />;
  }

  return (
    <Badge
      color="primary"
      className="text-white font-weight-normal position-absolute p-2"
      style={{ top: "0px" }}
    >
      <FontAwesomeIcon icon="book" />
      &nbsp;&nbsp; Ämne:&nbsp;{props.subject}
    </Badge>
  );
};

export default CourseSubject;
